module.exports = __webpack_public_path__ + "63554e1cd6b08504ccb68d97f19684ae.svg";